var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotifications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "19px",
    viewBox: "0 0 16 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Members-profile_owner_MVP-2_desktop",
    transform: "translate(-328.000000, -15.000000)",
    fill: "#8298AB",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-Profile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(60.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Notification",
    transform: "translate(264.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4472555,15.9867664 C19.6581925,16.2131872 19.7517134,16.4845832 19.7499624,16.7500054 C19.7464606,17.3265802 19.2936189,17.8750027 18.6214632,17.8750027 L5.1284992,17.8750027 C4.45634352,17.8750027 4.00387954,17.3265802 4,16.7500054 C3.99824906,16.4845832 4.09176995,16.2135305 4.30270695,15.9867664 C4.98190074,15.2569326 6.25280988,14.1589891 6.25280988,10.5625201 C6.25280988,7.83087914 8.16809996,5.64415873 10.7506706,5.10768388 L10.7506706,4.37503487 C10.7506706,3.75382816 11.2541178,3.25003755 11.8749812,3.25003755 C12.4958446,3.25003755 12.9992919,3.75382816 12.9992919,4.37503487 L12.9992919,5.10768388 C15.5818625,5.64415873 17.4971526,7.83087914 17.4971526,10.5625201 C17.4971526,14.1589891 18.7680617,15.2569326 19.4472555,15.9867664 Z M6.37410552,16.1875067 L17.3758569,16.1875067 C16.6298527,15.2045417 15.8142228,13.5746894 15.8103776,10.5829134 C15.8103776,10.5758753 15.8124718,10.5695582 15.8124718,10.5625201 C15.8124718,8.38774732 14.049754,6.6250295 11.8749812,6.6250295 C9.70020842,6.6250295 7.93749061,8.38774732 7.93749061,10.5625201 C7.93749061,10.5695582 7.93958488,10.5758753 7.93958488,10.5829134 C7.93573967,13.5743461 7.12010975,15.2041984 6.37410552,16.1875067 Z M11.8749812,21.2499946 C10.6332544,21.2499946 9.62605089,20.2427567 9.62605089,19 L14.1239116,19 C14.1239116,20.2427567 13.116708,21.2499946 11.8749812,21.2499946 Z",
    id: "\\uF0F3"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.32ef6569.svg";
export { ForwardRef as ReactComponent };